module.exports = __webpack_public_path__ + "img/bien.9e0df093.svg";